module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAUVBMVEUAAADdLkTdLkTdLkTdLkTdLkTdLkTdLkT/zE3/xEf/uD3/sDb/rDP/yErvbl/3jUn8ojrqWW5mdX/3oVn8vlHyhGLtZ2qZqrX0orLrYGz7tlMsubDZAAAACHRSTlMAYL//ACDP71kzCuAAAADKSURBVHgB7dc5coAwDIVh74glrDbE3P+gMSYJ1JYywxD9pYpv3MET743jpNKIlDQpYYx1GpmzB2Qrja6yCXKaIGeE1CRJoWggJTRRDP1vCIj6S6hu2i7XNjUG+uhuoV7UD+OpjEOPgqZbxdA8AyyXs5yXQgh8WA9lDR6KoW0D0LnP3Hlh6PnQdOtlULyciILCBQUU5OPvg3whNOdgj9/O/nMphMCHmJjgoQBCRAzxt58hiuh+2MkmBNmooZtZZMMvRTRF8T0OYoihL2HoZC7Y5d+GAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f1ea-1f1f8.png
// module id = 592
// module chunks = 0